import { render, staticRenderFns } from "./ManageRule.vue?vue&type=template&id=9b9f6362"
import script from "./ManageRule.vue?vue&type=script&lang=js"
export * from "./ManageRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports